import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentsSidebarFilterItemCheckboxChecked from './VeltCommentsSidebarFilterItemCheckboxChecked/VeltCommentsSidebarFilterItemCheckboxChecked';
import VeltCommentsSidebarFilterItemCheckboxUnchecked from './VeltCommentsSidebarFilterItemCheckboxUnchecked/VeltCommentsSidebarFilterItemCheckboxUnchecked';
import { transformWireframeProps } from '../../../../../utils/propUtils';
var VeltCommentsSidebarFilterItemCheckbox = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-item-checkbox-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterItemCheckbox.Checked = VeltCommentsSidebarFilterItemCheckboxChecked;
VeltCommentsSidebarFilterItemCheckbox.Unchecked = VeltCommentsSidebarFilterItemCheckboxUnchecked;
export default VeltCommentsSidebarFilterItemCheckbox;
